import { useTheme } from '../../contexts/ThemeContext';

function ThemeSlider({ themeKey, label, min, max, defaultVal }) {
  const { resolved, setOverride } = useTheme();
  const ui = resolved.ui || {};
  const value = resolved[themeKey] ?? defaultVal;
  return (
    <div>
      <label className="block text-xs mb-1" style={{ color: ui.textSecondary }}>
        {label}: {value}px
      </label>
      <input
        type="range" min={min} max={max} step={1}
        value={value}
        onChange={(e) => setOverride(themeKey, Number(e.target.value))}
      />
    </div>
  );
}

export default ThemeSlider;
